import {
  getAiModelIds,
  getAiModelOption,
  getAiModelOptions,
  getDefaultAiModelId,
  isAiModelIdForTask,
  type AiTaskModelId,
} from "../ai/tasks";

export const salesAgentModelOptionIds = getAiModelIds("sales");
export type SalesAgentModelOptionId = AiTaskModelId<"sales">;
export const defaultSalesAgentModelOptionId = getDefaultAiModelId("sales");
export const salesAgentModelOptions = getAiModelOptions("sales");
export const getSalesAgentModelOption = (id?: string | null) => getAiModelOption("sales", id);
export type SalesAgentModelOption = ReturnType<typeof getSalesAgentModelOption>;
export const isSalesAgentModelOptionId = (value?: string | null): value is SalesAgentModelOptionId =>
  isAiModelIdForTask("sales", value);
